import React, { useEffect, useState } from 'react'
import ToggleAdmins from '../components/ToggleAdmins'
import { getAllDocsInCollection, updateUserByUid, createDocumentWithId, deleteDocByCollectionAndId } from '../firebase'
import SearchBar from '../components/SearchBar';
function Admins({ user }) {

  const [users, setUsers] = useState([])
  const [search, setSearch] = useState('')
  const [filteredUsers, setFilteredUsers] = useState(users)

  useEffect(() => {
    if (!user) return;
    async function getUsers() {
      const usersData = await getAllDocsInCollection('Users')
      const filteredData = usersData.filter(userData => userData.uid !== user.uid);
      setUsers(filteredData);
    }
    getUsers();
  }, [user])

  useEffect(() => {
    const filtered = users.filter((user) => {
      const firstNameMatches = user.first_name.toLowerCase().includes(search.toLowerCase());
      const lastNameMatched = user.last_name.toLowerCase().includes(search.toLowerCase());
      const emailMatched = user.email.toLowerCase().includes(search.toLowerCase());
      return firstNameMatches || lastNameMatched || emailMatched;
    });
    setFilteredUsers(filtered);
  }, [search, users]);

  const containerStyles = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 20,
    paddingTop: 20,
    width: '100%'
  };
  const updateUserDB = async (user) => {
    await updateUserByUid(user.uid, {
      first_name: user.first_name,
      last_name: user.last_name,
      isAdmin: user.isAdmin
    });
    if (user.isAdmin) {
      await createDocumentWithId('Admins', user.uid);
    }
  };

  const updateAdmins = (user) => {
    const index = users.findIndex(
      (s) => s.uid === user.uid
    );
    if (index !== -1) {
      const updatedUser = [
        ...users.slice(0, index),
        user,
        ...users.slice(index + 1),
      ];
      setUsers(updatedUser)
      updateUserDB(user)
    }
  }
  const deleteAdmins = async (user) => {
    if (!user.isAdmin) {
      await deleteDocByCollectionAndId('Admins', user.uid)
    }
  }
  return (
    <div style={containerStyles}>
      <SearchBar placeholder={'Search by Name or Email'} search={search} setSearch={setSearch}></SearchBar>
      {filteredUsers.map((user) => (
        <ToggleAdmins key={user.uid} user={user} updateAdmins={updateAdmins} deleteAdmins={deleteAdmins}></ToggleAdmins>
      )
      )}
    </div>
  )
}

export default Admins